import { FranchiseDetail } from "./models/FranchiseDetail";
import { locationSearchMapConfig } from './config';
import { cachedAPIWrapper } from "../apiCaching/apiWrapper";
import { logInTestEnv } from "../util/logger";
import { rearrangeCanadaFirst } from "../util/share";
import { DomainIdentifier } from "../util/domainService";
import { getCountryCode } from "../location-search-map/getCountryCode";

export async function getFranchiseWebLocations(): Promise<void | FranchiseDetail[]>{        
        return getDataFromApi();
}

const getDataFromApi =  () => {
    const serviceId = (document.getElementById("fetchcity-serviceid") as HTMLInputElement)?.value;
    let url = locationSearchMapConfig.franchiseWebLocationsApiCall;
    if(serviceId){
        url+="/"+serviceId;
    }
    return cachedAPIWrapper(url)
        .then(response => {
            return response;
        })
        .then(response =>
        {
            sessionStorage.setItem('locationReorderedForCA', 'false');
            return filterData(response);
        })
        .catch(error =>
        {
            logInTestEnv("Error calling getFranchiseWebLocations:", error);
        });
}

export const filterData = (data: any): FranchiseDetail[] => {
    let details = data.flatMap((f: { franchiseDetails: any; })=>f.franchiseDetails);
    let result = [];  
    // remove duplicates
    const set = new Set();
    for(let detail of details) {
        const businessName = detail?.doingBusinessAs?.toLocaleLowerCase() ?? ""; 
		const isTestAccount = businessName.includes("test account");
		const isDemoAccount = businessName.includes("demo");
        if(!set.has(detail.franchiseWebLocationId) && detail.websiteUrl !== null && !isTestAccount && !isDemoAccount) {
            result.push(detail);
            set.add(detail.franchiseWebLocationId);
        }
    }
    //If localized to a Canadian location, re-order canada data first
    const localisation = DomainIdentifier();
    const countryCode = getCountryCode();
    const localisedcountryCode = sessionStorage.getItem('countryCode');
    if (localisation === 'ca' || countryCode === 'ca' || localisedcountryCode === 'ca') {
        result = rearrangeCanadaFirst(result);
        sessionStorage.setItem('locationReorderedForCA', 'true');
    }
    return result;
}
